import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VBtn,{attrs:{"text":"","icon":"","dark":"","small":"","title":"Download as SVG"},on:{"click":_vm.downloadAsSVG}},[_c(VIcon,[_vm._v("mdi-download")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }